import { Grid, TablePagination, Typography } from '@material-ui/core';
import {
  Timeline as TimelineContainer,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from '@material-ui/lab';
import React, { useState } from 'react';
import { historicoStyles } from './styles';

const Timeline = ({ registros, pageSize = 3, getIcone, getSubtitulo, getDescricao, iconeStyles }) => {
  const [page, setPage] = useState(0);

  const styles = historicoStyles();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <>
      <TimelineContainer align="left">
        {registros?.slice(page * pageSize, page * pageSize + pageSize)?.map((registro) => (
          <TimelineItem className={styles.timelineItem}>
            <TimelineSeparator>
              <TimelineDot className={`${styles.timelineDot} ${iconeStyles}`}>{getIcone(registro)}</TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <Grid container>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" className={styles.historicoDataHora}>
                    {getSubtitulo(registro)}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1">{getDescricao(registro)}</Typography>
                </Grid>
              </Grid>
            </TimelineContent>
          </TimelineItem>
        ))}
      </TimelineContainer>

      {registros?.length > 3 && (
        <TablePagination
          component="div"
          className="pb-0"
          count={registros.length}
          rowsPerPage={pageSize}
          labelRowsPerPage={false}
          page={page}
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
          onChangePage={handleChangePage}
          rowsPerPageOptions={[]}
        />
      )}
    </>
  );
};

export default Timeline;
